import React, { useMemo } from 'react';
import { useRoute } from '@react-navigation/native';

import { GET_SERVICE_RUN_WITH_PICKLISTS } from '../../../common/graphql/serviceRun';
import { Screen } from '../../design/components';
import { useFreshDetailQueryOptions } from '../../hooks';
import { useOfflineQueue } from '../../offline';

import PickListSummary from './PickListSummary';
import TrainingModeBanner from '../myDay/TrainingModeBanner';
import { isMyDayTraining } from '../myDay/myDayTraining';

const SUMMARY_REFRESH_INTERVAL_MS = 15000;

const PickListSummaryView = () => {
	const route = useRoute();
	const id = route.params?.id;
	const { isOnline } = useOfflineQueue();
	const trainingContext = route.params?.myDayTraining;
	const isTraining = isMyDayTraining(trainingContext);
	const {
		canRenderDetailQuery,
		detailQueryOptions,
	} = useFreshDetailQueryOptions({ noCache: isTraining });
	const summaryQueryOptions = useMemo(() => ({
		...detailQueryOptions,
		pollInterval: isOnline ? SUMMARY_REFRESH_INTERVAL_MS : 0,
		notifyOnNetworkStatusChange: false,
	}), [detailQueryOptions, isOnline]);

	// The summary brings its own list (scroll view or grid), so the frame does not scroll.
	return (
		<Screen
			scroll={false}
			isLoading={!canRenderDetailQuery}
			banner={<TrainingModeBanner trainingContext={trainingContext} isOnline={isOnline} />}
		>
			<PickListSummary
				id={id}
				query={GET_SERVICE_RUN_WITH_PICKLISTS}
				detailQueryOptions={summaryQueryOptions}
				blockDataWhileLoading={false}
			/>
		</Screen>
	);
};

export default React.memo(PickListSummaryView);
